import { useTrans } from "@/i18n"
import { EmptyGridState } from "../../../EmptyGridState"
import { Heading } from "../../../Typography"

function FloatingEmptyGridState() {
	return (
		<div className="absolute top-0 left-0 flex size-full items-center justify-center">
			<EmptyGridState className="size-full max-h-40 justify-center" />
		</div>
	)
}

export function ProductionDailyNoData({
	variant = "today",
}: {
	variant?: "today" | "past"
}) {
	const t = useTrans("project")

	return (
		<div className="absolute top-1/2 left-0 flex w-full -translate-y-1/2 flex-col items-center justify-center">
			<FloatingEmptyGridState />
			<div className="relative z-2 px-8">
				<Heading as="h2" styleAs="h4" className="text-center">
					{variant === "today"
						? t("project:data.production_today.no_data.title")
						: t(
								"project:data.production_today.no_data.in_the_past.title",
							)}
				</Heading>
				<p className="mt-2 max-w-2xl text-center text-sm text-gray-500">
					{variant === "today"
						? t("project:data.production_today.no_data.copy")
						: t(
								"project:data.production_today.no_data.in_the_past.copy",
							)}
				</p>
			</div>
		</div>
	)
}
